import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/spravato")({
  beforeLoad: () => {
    throw redirect({ to: "/services/spravato" });
  },
});
